import { shortenTxt } from "shared/src/common/transform";
import { ExtError } from "shared/src/framework/error";
import {
    ApiClientRequest,
    processResponseBodyStr,
    RespStatusBody,
    validateApiClientRequest,
} from "shared/src/framework/network/api-client";
import "whatwg-fetch";

export async function BrowserApiClient<T extends object | number>(
    req: ApiClientRequest
): Promise<RespStatusBody<T>> {
    validateApiClientRequest(req);
    const { host, urlPath, method, body, headers } = req;
    const url = host ? host + urlPath : urlPath;
    const bodySer = body && typeof body != "string" ? JSON.stringify(body) : body || "";
    const errStr = () => `${url} ${body ? "with body " + shortenTxt(JSON.stringify(body)) : ""}`;
    const reqOptions: RequestInit = {
        method,
        headers: headers as any,
        body: bodySer,
    };
    let response: Response;
    try {
        response = await fetch(url, reqOptions);
    } catch (err: any) {
        throw new ExtError(`Network error in fetching ${errStr()}`, "NETWORK_ERROR", {
            prevErrors: err,
        });
    }

    let respStr: string;
    try {
        respStr = await response.text();
    } catch (e: any) {
        throw new ExtError(`Unable to get response as text ${errStr()}`, "INVALID_DATA", {
            prevErrors: e,
        }).setHttpStatus(response.status);
    }
    return processResponseBodyStr<T>(
        respStr,
        response.status,
        response.headers.get("Content-Type")
    );
}
